import React, { useState } from "react";

export default function InfoTag({ text = "Info", content = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="relative inline-block">
      <button
        className="mt-1 text-[11px] px-2 py-0.5 rounded-full bg-amber-100 text-amber-800 border border-amber-200 hover:bg-amber-200"
        onClick={() => setOpen((s) => !s)}
        title="Voir les informations"
      >
        {text}
      </button>
      {open && (
        <div
          className="absolute z-50 mt-2 w-72 max-w-[80vw] p-3 rounded-lg bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-xl"
          onMouseLeave={() => setOpen(false)}
        >
          <div className="text-xs whitespace-pre-wrap">{content}</div>
        </div>
      )}
    </div>
  );
}
